/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fine_Sour_Cuckoo_BuyInputs */

const fr_fine_sour_cuckoo_buy = /** @type {(inputs: Fine_Sour_Cuckoo_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme précédents`)
};

/**

* @param {Fine_Sour_Cuckoo_BuyInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fine_sour_cuckoo_buy = /** @type {((inputs?: Fine_Sour_Cuckoo_BuyInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fine_Sour_Cuckoo_BuyInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fine_sour_cuckoo_buy(inputs)
});